<div class="custella-modal">
    
         <div class="custella-modal-header align-items-center">
            <div class="custella-modal-header-text">Import {{translate?.asset.label.plural}}</div>
            <i class="pi pi-times" [pTooltip]="translate?.general?.buttons?.close.singular" tooltipPosition="left" (click)="modalRef.hide()"></i>
        </div>

        <div class="custella-modal-body">
            <div class="custella-form-container box-none m-0">
                <div class="import-steps-modal">
                <h5>Bring your data into FieldEx with the following steps:</h5>
                    <ol>
                        <li>1.
                        <strong>Upload your data:</strong> Drag and drop a .csv or .xls file, or browse your computer. A sample CSV file will be available in the next page.
                        </li>
                        <li>2.
                        <strong>Map your fields:</strong> Match the columns in your file to the corresponding fields in FieldEx.
                        </li>
                        <li>3.
                        <strong>Verify and edit:</strong> Review your data and make any necessary changes. The system will highlight any missing information in required fields to prevent import errors.
                        </li>
                        <li>4.
                        <strong>Import your data:</strong> Once everything looks good, click import to bring your data into FieldEx.
                        </li>
                    </ol>
                </div>
            </div>
        </div>

        <div class="custella-modal-footer flex-align-center justify-content-end gap-2">
            <button class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
            <!-- <p-button styleClass="h-32" [label]="translate?.general.buttons.next.singular"></p-button> -->
            <csvbox-button
                [options]="optionsData"
                [licenseKey]="licenseKey"
                [imported]="imported.bind(this)" 
                [loadStarted]="loadStarted.bind(this)"
                [onClose]="importerReady.bind(this)"
                class="import-button ms-2"
                [lazy]="lazy">
                {{translate?.general.buttons.next.singular}}
            </csvbox-button>
        </div>

        <ngx-spinner bdColor = "rgb(255 255 255 / 76%)" size = "medium" color = "#6366f1" type = "ball-clip-rotate-multiple" ><p style="color: white" > Loading... </p></ngx-spinner>
</div>